import {
  AbstractAuthModuleService,
  AbstractChannelBoxService,
  AbstractChatService,
  AbstractNotificationsDrawerService,
  AbstractNotificationsService,
  AbstractTradingService,
  AbstractUserService,
  AuthService,
  MY_ACCOUNT_AUTH_SERVICE,
  MY_ACCOUNT_USER_SERVICE,
} from '@aionzdev/modules';
import { AbstractPurchasingService } from '../../pages/purchasing-manager';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { PurchasingService } from '../../pages/purchasing-manager/services/purchasing.service';
import { AuthModuleService } from '../services/auth-module.service';
import { ChannelBoxService } from '../services/channel-box.service';
import { ChatsService } from '../services/chat.service';
import { NotificationDrawerStateService } from '../services/notification-drawer-state.service';
import { NotificationsService } from '../services/notifications.service';
import { TradingService } from '../services/trading.service';
import { UserService } from '../services/user.service';
import { MyAccountAuthService } from '../services/my-account-auth.service';
import { MyAccountUserService } from '../services/my-account-user.service';

export function provideCoreServices(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AbstractAuthModuleService, useExisting: AuthModuleService },
    { provide: AuthService, useExisting: AuthModuleService },
    { provide: AbstractNotificationsService, useExisting: NotificationsService },
    { provide: AbstractNotificationsDrawerService, useExisting: NotificationDrawerStateService },
    { provide: AbstractPurchasingService, useExisting: PurchasingService },
    { provide: AbstractChatService, useExisting: ChatsService },
    { provide: AbstractUserService, useExisting: UserService },
    { provide: MY_ACCOUNT_AUTH_SERVICE, useExisting: MyAccountAuthService },
    { provide: MY_ACCOUNT_USER_SERVICE, useExisting: MyAccountUserService },
    { provide: AbstractChannelBoxService, useExisting: ChannelBoxService },
    { provide: AbstractTradingService, useExisting: TradingService },
  ]);
}
